import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-password-tooltip',
  imports: [],
  templateUrl: './password-tooltip.component.html',
  styleUrl: './password-tooltip.component.css'
})
export class PasswordTooltipComponent {
  @Input() passCond1: boolean = false;
  @Input() passCond2: boolean = false;
  @Input() passCond3: boolean = false;
  @Input() passCond4: boolean = false;
  @Input() passCond5: boolean = false;
}
